<style scoped>
.title-container {
  color: #606060;
}

.title-container hr {
  background-color: #929292;
  margin-top: 0;
  margin-bottom: 4px;
}

.title-container .title {
  margin-bottom: 0;
}

.block-container {
  border: 1px solid #d6d6d6;
  min-height: 315px;
  background-color: #f8f9fa !important;
}
</style>

<template>
  <div>
    <header class="spaced-header bg-light">
      <b-col class="text-center text-light-blue">
        <span class="h3">
          <font-awesome-icon v-if="icon" :icon="icon" />
          {{ title }}
        </span>
      </b-col>
    </header>
    <div class="container">
      <b-row>
        <b-col>
          <slot></slot>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    icon: String,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/TitleContainer.vue